// +----------------------------------------------------------------------
// | Desc:【框架集】全局vue框架
// +----------------------------------------------------------------------
import Vue from 'vue'

// +----------------------------------------------------------------------
// | Desc:【全局框架集】路由配置
// +----------------------------------------------------------------------
import router from '@/layout/config/routerConfig'

// +----------------------------------------------------------------------
// | Desc:【全局框架集】用户权限
// +----------------------------------------------------------------------
import authConfig from '@/layout/config/authConfig.js';
Vue.use(authConfig);

// +----------------------------------------------------------------------
// | Desc:【全局框架集】UI框架
// +----------------------------------------------------------------------
import ViewUI from '@/layout/style/IVIEWUI/index.js';
Vue.use(ViewUI, {
    table: {
        border: true
    }
});

// +----------------------------------------------------------------------
// | Desc:【全局框架集】注册自定义弹窗组件
// +----------------------------------------------------------------------
import $QHopen from '@/layout/component/QHopen/QHopen.js';
Vue.use($QHopen);

// +----------------------------------------------------------------------
// | Desc:【全局框架集】注册自定义图片弹窗组件
// +----------------------------------------------------------------------
import $QHImgopen from '@/layout/component/QHImgopen/QHImgopen.js';
Vue.use($QHImgopen);

// +----------------------------------------------------------------------
// | Desc:【全局框架集】注册自建框架依赖
// +----------------------------------------------------------------------
import '@/layout/component/config.js';

// +----------------------------------------------------------------------
// | Desc:【NODEMODULES框架集】MD5加密库
// +----------------------------------------------------------------------
import md5 from 'js-md5'
Vue.prototype.$MD5 = md5

// +----------------------------------------------------------------------
// | Desc:【NODEMODULES框架集】SlideVerify滑块行为验证插件
// +----------------------------------------------------------------------
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);

// +----------------------------------------------------------------------
// | Desc:【NODEMODULES框架集】简化JS编程中的常见任务
// +----------------------------------------------------------------------
import FMT from 'lodash';
Vue.prototype.$FMT = FMT

export {
    router
};